"use client";

import type { ReactNode } from "react";
export function FilterGroup({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="ph-filter-group">
      <span className="ph-filter-glabel">{label}</span>
      <div className="ph-filter-chip-row">{children}</div>
    </div>
  );
}
